// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Berkshire+Swash&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.cdnfonts.com/css/sansation);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* login.css */

h1 {
  font-size: 80px; /* Adjust font size for responsiveness */
  font-family: 'Berkshire Swash';
  margin-top: 40px; /* Space below the header */
}

.animate-gradient-text {
  background-image: linear-gradient(-45deg, #ee7752, #e73c7e, #23a6d5, #23d5ab);
  background-size: 200%;
  -webkit-text-fill-color: transparent;
  -webkit-background-clip: text;
  background-clip: text;
  animation: animated-gradient 5s ease infinite;
  margin:10px;
}

@keyframes animated-gradient {
  
  0%, 100% {
      background-position: 0 50%;
      margin:10px;
  }
  50% {
      background-position: 100% 50%;
  }
}

h5 {
  font-size: 35px;
  margin: 0;
}

.main_box {
  width: 100%;
  font-family: 'Sansation';
  font-style: normal;
  text-align: center;
  font-size: 35px;
  position: relative;
  padding: 0;   
  margin: 0;
  margin-bottom: 10px;
  top: 200px; /* Adjust this value to change Y position */
  left: 50%;
  transform: translate(-50%, -50%);
}

.g_body {
  margin: 0;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 15px;
}

.g-button {
  margin: 0;
  background: #FFFFFF;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  padding: 0;
  border: none;
  display: flex;
}

.g-logo {
  margin: 0;
  padding: 0;
  width: 28px;
  height: 28px;
  padding: 15px 10px;
}

.g-text {
  margin: 0;
  padding: 0;
  font-size: 16px;
  padding: 15px 10px;
  
  color: black;
  font-family: 'Sansation';
  font-style: normal;
  font-size: x-large;
  text-align: center;
}

@media screen and (max-width: 500px) {
  h1 {
      font-size: 60px;
      margin:10px /* Adjust for smaller screens */
  }
  .main_box {
      font-size: 20px;
  }
}

.g_body {
  transform: scale(1.30); /* Visually enlarges font and button */
  transform-origin: center;
}
`, "",{"version":3,"sources":["webpack://./src/Components/login.css"],"names":[],"mappings":"AAAA,cAAc;;AAId;EACE,eAAe,EAAE,wCAAwC;EACzD,8BAA8B;EAC9B,gBAAgB,EAAE,2BAA2B;AAC/C;;AAEA;EACE,6EAA6E;EAC7E,qBAAqB;EACrB,oCAAoC;EACpC,6BAA6B;EAC7B,qBAAqB;EACrB,6CAA6C;EAC7C,WAAW;AACb;;AAEA;;EAEE;MACI,0BAA0B;MAC1B,WAAW;EACf;EACA;MACI,6BAA6B;EACjC;AACF;;AAEA;EACE,eAAe;EACf,SAAS;AACX;;AAEA;EACE,WAAW;EACX,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,mBAAmB;EACnB,UAAU,EAAE,2CAA2C;EACvD,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,2CAA2C;EAC3C,mBAAmB;EACnB,UAAU;EACV,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,eAAe;EACf,kBAAkB;;EAElB,YAAY;EACZ,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE;MACI,eAAe;MACf,UAAU,EAAE,+BAA+B;EAC/C;EACA;MACI,eAAe;EACnB;AACF;;AAEA;EACE,sBAAsB,EAAE,sCAAsC;EAC9D,wBAAwB;AAC1B","sourcesContent":["/* login.css */\r\n@import url('https://fonts.googleapis.com/css2?family=Berkshire+Swash&display=swap');\r\n@import url('https://fonts.cdnfonts.com/css/sansation');\r\n\r\nh1 {\r\n  font-size: 80px; /* Adjust font size for responsiveness */\r\n  font-family: 'Berkshire Swash';\r\n  margin-top: 40px; /* Space below the header */\r\n}\r\n\r\n.animate-gradient-text {\r\n  background-image: linear-gradient(-45deg, #ee7752, #e73c7e, #23a6d5, #23d5ab);\r\n  background-size: 200%;\r\n  -webkit-text-fill-color: transparent;\r\n  -webkit-background-clip: text;\r\n  background-clip: text;\r\n  animation: animated-gradient 5s ease infinite;\r\n  margin:10px;\r\n}\r\n\r\n@keyframes animated-gradient {\r\n  \r\n  0%, 100% {\r\n      background-position: 0 50%;\r\n      margin:10px;\r\n  }\r\n  50% {\r\n      background-position: 100% 50%;\r\n  }\r\n}\r\n\r\nh5 {\r\n  font-size: 35px;\r\n  margin: 0;\r\n}\r\n\r\n.main_box {\r\n  width: 100%;\r\n  font-family: 'Sansation';\r\n  font-style: normal;\r\n  text-align: center;\r\n  font-size: 35px;\r\n  position: relative;\r\n  padding: 0;   \r\n  margin: 0;\r\n  margin-bottom: 10px;\r\n  top: 200px; /* Adjust this value to change Y position */\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n}\r\n\r\n.g_body {\r\n  margin: 0;\r\n  padding: 0;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  margin-top: 15px;\r\n}\r\n\r\n.g-button {\r\n  margin: 0;\r\n  background: #FFFFFF;\r\n  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);\r\n  border-radius: 10px;\r\n  padding: 0;\r\n  border: none;\r\n  display: flex;\r\n}\r\n\r\n.g-logo {\r\n  margin: 0;\r\n  padding: 0;\r\n  width: 28px;\r\n  height: 28px;\r\n  padding: 15px 10px;\r\n}\r\n\r\n.g-text {\r\n  margin: 0;\r\n  padding: 0;\r\n  font-size: 16px;\r\n  padding: 15px 10px;\r\n  \r\n  color: black;\r\n  font-family: 'Sansation';\r\n  font-style: normal;\r\n  font-size: x-large;\r\n  text-align: center;\r\n}\r\n\r\n@media screen and (max-width: 500px) {\r\n  h1 {\r\n      font-size: 60px;\r\n      margin:10px /* Adjust for smaller screens */\r\n  }\r\n  .main_box {\r\n      font-size: 20px;\r\n  }\r\n}\r\n\r\n.g_body {\r\n  transform: scale(1.30); /* Visually enlarges font and button */\r\n  transform-origin: center;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
